





























import { computed, defineComponent, watchEffect } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import {
  AppointmentType,
  AppointmentTypeKind,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString, getCostByCurrency } from "@/lib/moneyHelpers";
import { ListFields } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSelect from "@/components/BaseSelect";

export default defineComponent({
  name: "AppointmentTypeItemSettings",
  components: { BaseSelect, BaseIconButton },
  props: {
    showLabel: {
      type: Boolean,
      required: true,
    },
    appointmentType: {
      type: Object as () => AppointmentType,
      required: true,
    },
    paymentPackages: {
      type: Array as () => PaymentPackage[],
      default: () => [],
    },
    filterDurations: {
      type: Array as () => number[],
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const packageOptions = computed<ListFields>(() =>
      props.paymentPackages.map(p => ({
        text: formatMoneyString(getCostByCurrency(p)?.cost || 0),
        value: p.id,
      }))
    );

    const timeOptions = computed<ListFields>(() => [
      ...(props.appointmentType.kind !== AppointmentTypeKind.TOUR_GUIDE
        ? [
            {
              value: 5,
              text: $t("5 min"),
            },
            {
              value: 15,
              text: $t("15 min"),
            },
            {
              value: 30,
              text: $t("30 min"),
            },
            {
              value: 45,
              text: $t("45 min"),
            },
          ]
        : []),
      {
        value: 60,
        text: $t("1 hour"),
      },
      {
        value: 120,
        text: $t("2 hours"),
      },
      {
        value: 180,
        text: $t("3 hours"),
      },
      ...(props.appointmentType.kind === AppointmentTypeKind.TOUR_GUIDE
        ? [
            {
              value: 360,
              text: $t("6 hours"),
            },
            {
              value: 720,
              text: $t("12 hours"),
            },
            {
              value: 1440,
              text: $t("24 hours"),
            },
          ]
        : []),
    ]);

    const filteredTimeOptions = computed<ListFields>(() =>
      timeOptions.value.filter(
        o => props.appointmentType.duration === o.value || !props.filterDurations.includes(o.value)
      )
    );

    const init = () => {
      if (!props.appointmentType.duration) {
        if (filteredTimeOptions.value.length) {
          emit("update", {
            id: props.appointmentType.id,
            duration: filteredTimeOptions.value[0].value,
            pricePackageId: props.appointmentType.pricePackageId,
          });
        } else {
          emit("remove", props.appointmentType.id);
        }
      }
    };
    watchEffect(() => {
      emit("empty-duration", filteredTimeOptions.value.length === 1);
    });

    init();

    return { filteredTimeOptions, timeOptions, packageOptions };
  },
});
